import { LanguageService } from 'services/language-service';
import { CONVERSATIONS_EXPORT_TIMEOUT_MS } from 'shared/constants/conversations';
import {
  Conversation,
  ExportConversationsDto,
  GetSmartAssistantConversationsQueryDto,
  UpdateConversationTitleDto
} from 'shared/interfaces/Conversation';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const conversationBaseEndpoint = '/conversation';

export const ConversationService = {
  getSmartAssistantConversations: async (smartAssistantId: string): Promise<Conversation[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${conversationBaseEndpoint}/smart-assistant/${smartAssistantId}`
    });

    return response.data;
  },
  deleteConversation: async (conversationId: string): Promise<string> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${conversationBaseEndpoint}/${conversationId}`
    });

    return response.data._id;
  },
  updateConversationTitle: async (updateTitleDto: UpdateConversationTitleDto): Promise<Conversation> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${conversationBaseEndpoint}/update-title`,
      data: updateTitleDto
    });

    return response.data;
  },
  getAllSmartAssistantConversations: async (
    smartAssistantId: string,
    query: GetSmartAssistantConversationsQueryDto
  ): Promise<Conversation[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${conversationBaseEndpoint}/with-smart-assistant/${smartAssistantId}`,
      params: query
    });

    return response.data;
  },
  exportConversations: async (exportConversationsDto: ExportConversationsDto): Promise<ArrayBuffer> => {
    const response = await axiosBaseInstance({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${conversationBaseEndpoint}/export-conversations/${exportConversationsDto.smartAssistantId}`,
      params: {
        ...exportConversationsDto.query,
        exportType: exportConversationsDto.type,
        locale: LanguageService.getCurrentLanguage(),
        timezoneOffsetMs: new Date().getTimezoneOffset() * 60 * 1000 * -1 // -1 because getTimezoneOffset returns positive value for negative offset
      },
      timeout: CONVERSATIONS_EXPORT_TIMEOUT_MS
    });

    return response.data;
  }
};
